export enum NoticeKey {
  UPCOMING_EMPTY_STATE = 'upcoming_empty_state',
  CONTACTS_EMPTY_STATE = 'contacts_empty_state',
  CONTACTS_FINANCIAL_PLANNING_ONBOARDING_BANNER = 'contacts_financial_planning_onboarding_banner',
  UPCOMING_ZOOM_ONBOARDING_BANNER = 'upcoming_zoom_onboarding_banner',
  UPCOMING_EMAIL_ONBOARDING_BANNER = 'upcoming_email_onboarding_banner',
  UPCOMING_MCP_CONNECT_PROMO_BANNER = 'upcoming_mcp_connect_promo_banner',
  UPCOMING_MCP_INTEREST_PROMO_BANNER = 'upcoming_mcp_interest_promo_banner',
  PAST_MEETINGS_MCP_CONNECT_PROMO_BANNER = 'past_meetings_mcp_connect_promo_banner',
  PAST_MEETINGS_MCP_INTEREST_PROMO_BANNER = 'past_meetings_mcp_interest_promo_banner',
  CONTACTS_MCP_CONNECT_PROMO_BANNER = 'contacts_mcp_connect_promo_banner',
  CONTACTS_MCP_INTEREST_PROMO_BANNER = 'contacts_mcp_interest_promo_banner',
  INSIGHTS_MCP_CONNECT_PROMO_BANNER = 'insights_mcp_connect_promo_banner',
  INSIGHTS_MCP_INTEREST_PROMO_BANNER = 'insights_mcp_interest_promo_banner',
  INTEGRATION_SETTINGS_MCP_ADMIN_PROMO_BANNER = 'integration_settings_mcp_admin_promo_banner',
}

export interface Notice {
  key: NoticeKey
  isDismissed: boolean
  dismissedAt: string | null
}
